import React from 'react';

import CardsPainel from '../CardsComponents/cardsPainel';


function OverviewPanel({
  backupAlertsCount,
  openTicketsCount,
  clientsWithExpiringHoursCount,
  serversWithErrorCount,
}) {
  return (
    <div
      style={{
        width: '100%',
        maxWidth: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-evenly',
      }}
    >
      <CardsPainel
        colorCard={'red'}
        number={backupAlertsCount}
        HeaderBadge="Backups"
        icon={'exclamation-triangle'}
        description="Alertas de backups e réplicas"
      />
      <CardsPainel
        colorCard={'yellow'}
        number={openTicketsCount}
        HeaderBadge="Chamados"
        icon={'exclamation-triangle'}
        description="Chamados em aberto"
      />
      <CardsPainel
        colorCard={'yellow'}
        number={clientsWithExpiringHoursCount}
        HeaderBadge="Avulsos"
        icon={'exclamation-triangle'}
        description="Clientes com horas que vão vencer"
      />
      <CardsPainel
        colorCard={'red'}
        number={serversWithErrorCount}
        HeaderBadge="Monitor"
        icon="exclamation-triangle"
        description="Itens com alerta no monitoramento"
      />
    </div>
  );
}

export default OverviewPanel;
